import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_general/orders')({
	staticData: {
		crumb: ({ context: { L } }) => L.Orders.Title()
	}
})
